<template>
  <div class="progress-circle">
    <svg viewBox="0 0 100 100" width="30" height="30">
      <!-- Фоновый круг -->
      <circle cx="50" cy="50" r="45" stroke="#007AFF" stroke-opacity="0.15" stroke-width="12" fill="none" />

      <!-- Прогресс-круг -->
      <circle cx="50" cy="50" r="45" :stroke="completed ? '#00C896' : '#007AFF'" stroke-width="12" fill="none" :stroke-dasharray="circumference" :stroke-dashoffset="dashOffset" stroke-linecap="round" transform="rotate(-90 50 50)" />
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      progress: { type: Number, default: 0 },
      completed: { type: Boolean, default: false },
    },
    data() {
      return {
        radius: 45,
      }
    },
    computed: {
      circumference() {
        return 2 * Math.PI * this.radius
      },
      dashOffset() {
        return this.circumference - (this.progress / 100) * this.circumference
      },
    },
  }
</script>

<style scoped>
  .progress-circle svg circle {
    transition: stroke-dashoffset 0.3s ease-in-out;
  }
</style>
